import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { CreateQuickshareLink } from './CreateQuickshareLink'
import { APPConfig } from 'config/appConfig'
import { convertToBoolean } from 'src/utils'

const REMOTE_CONFIG = {
  appName: 'personaloffer-mfe',
  component: 'ShareModal',
}

const getPreviewUrl = url =>
  url ? (url.includes('?') ? `${url}&preview` : `${url}?preview`) : null

@observer
class ShareOfferModalLoader extends React.Component {
  renderShareModal = () => {
    const {
      showModal,
      onClose,
      url,
      product,
      daysUntilExpiry,
      showOfferDashboardMessage,
      onOfferCreated,
    } = this.props

    const params = {
      open: showModal,
      onClose,
      product,
      showPreviewAndEditButtons: false,
      showOfferDashboardMessage,
      hideLoader: true,
      ...(daysUntilExpiry !== undefined && { daysUntilExpiry }),
      ...(url && { shareUrl: url, previewUrl: getPreviewUrl(url) }),
      ...(onOfferCreated && { onOfferCreated }),
    }

    return (
      <div className="share-offer-modal-loader">
        <MicroFrontendLoader
          remoteConfig={REMOTE_CONFIG}
          params={params}
          isToEnableSSR={false}
        />
      </div>
    )
  }

  render() {
    const { showModal, onClose, url, product } = this.props

    const isProductOfferAdminEnabled = convertToBoolean(
      APPConfig.getAppConfig()?.enableProductOfferV2
    )

    if (!isProductOfferAdminEnabled) {
      return (
        <CreateQuickshareLink
          showModal={showModal}
          onClose={onClose}
          url={url}
          product={product}
        />
      )
    }

    if (!showModal) {
      return null
    }
    return this.renderShareModal()
  }
}

ShareOfferModalLoader.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string,
  product: PropTypes.object.isRequired,
  daysUntilExpiry: PropTypes.number,
  showOfferDashboardMessage: PropTypes.bool,
  onOfferCreated: PropTypes.func,
}

ShareOfferModalLoader.defaultProps = {
  url: undefined,
  daysUntilExpiry: undefined,
  showOfferDashboardMessage: false,
  onOfferCreated: undefined,
}

export default ShareOfferModalLoader
export { ShareOfferModalLoader }
